import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

import { User } from '@core/models/user';
import { getEntryUrlByRole } from '@core/enums/entry-url.enum';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(null);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  private get user(): User {
    return this.currentUserSubject.value;
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public set currentUserValue(user: User) {
    this.currentUserSubject.next(user);
  }

  public get loginIn(): boolean {
    return !!this.currentUserSubject.value;
  }

  public get cabinetLink(): string {
    return this.user && getEntryUrlByRole(this.user.role);
  }
}
